import httpClient, { paramsToString } from '@/services/http/httpClient'

export const apiGetSinisterSchedule = (sinisterId) => {
  const params = new URLSearchParams()
  params.set('sinister_id', sinisterId)

  return httpClient
    .get(`schedule/info${paramsToString(params)}`)
    .then((data) => data)
    .finally(() => {
      let token = sessionStorage.getItem('mavAuth')

      sessionStorage.setItem('mavAuth', token)
    })
}

export const apiPostSinisterScheduleContact = (sinisterId) => {
  return httpClient
    .post('schedule/contact', { sinister_id: sinisterId })
    .then((data) => data)
    .catch((error) => Promise.reject(error))
}

export const apiPostSinisterScheduleReserve = ({
  sinisterId,
  scheduleId,
  appointmentDate
}) => {
  return httpClient
    .post('schedule/reserve', {
      sinister_id: sinisterId,
      cita_id: scheduleId,
      time: appointmentDate
    })
    .then((data) => data)
    .catch((error) => Promise.reject(error))
    .finally(() => {
      let token = sessionStorage.getItem('mavAuth')

      sessionStorage.setItem('mavAuth', token)
    })
}
